import biboClient from './biboClient';

const axiosInstance = biboClient.create();

export default {
  getCubes: () => {
    return axiosInstance.get('/api/datagrabber/');
  },
  getConfiguration: cubeId => {
    return axiosInstance.get(`/api/datagrabber/${cubeId}/configuration`);
  },
  getJobtime: cubeId => {
    return axiosInstance.get(`/api/datagrabber/${cubeId}/jobtime`);
  },
  getFilterOptions: (cubeId, options) => {
    return axiosInstance.get(
      `/api/datagrabber/${cubeId}/filteroptions`,
      options
    );
  },
  grabData: (cubeId, data) => {
    return axiosInstance.post(`/api/datagrabber/${cubeId}/grabdata`, data);
  },
  getMdxQuery: (cubeId, data) => {
    return axiosInstance.post(`/api/datagrabber/${cubeId}/mdxquery`, data);
  },


  getTemplates: cubeId => {
    return axiosInstance.get(`/api/datagrabber/${cubeId}/templates`);
  },
  getTemplate: (cubeId, templateId) => {
    return axiosInstance.get(`/api/datagrabber/${cubeId}/templates/${templateId}`);
  },
  postTemplates: (cubeId, data) => {
    return axiosInstance.post(`/api/datagrabber/${cubeId}/templates`, data);
  },
  putTemplates: (cubeId, templateId, data) => {
    return axiosInstance.put(`/api/datagrabber/${cubeId}/templates/${templateId}`, data);
  },
  deleteTemplates: (cubeId, templateId) => {
    return axiosInstance.delete(`/api/datagrabber/${cubeId}/templates/${templateId}`);
  },

  postDatasets: (data) => {
    return axiosInstance.post(`/api/datasets`, data);
  },
};
